import { render, staticRenderFns } from "./TreeSelect.vue?vue&type=template&id=d672eb36&scoped=true&"
import script from "./TreeSelect.vue?vue&type=script&lang=js&"
export * from "./TreeSelect.vue?vue&type=script&lang=js&"
import style0 from "./TreeSelect.vue?vue&type=style&index=0&id=d672eb36&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d672eb36",
  null
  
)

export default component.exports